
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import DonationDashboard from './components/Dashboard';
import { AuthProvider } from './context/AuthContext';
import React, { useEffect } from 'react';
function App() {
  useEffect(() => {
    // This effect will run once when the component mounts

    const handleRightClick = (e) => {
      e.preventDefault(); // Prevent right-click context menu
    };

    const handleKeyDown = (e) => {
      // Prevent F12, Ctrl+Shift+I, and Ctrl+U
      if (e.key === 'F12' || (e.ctrlKey && (e.key === 'I' || e.key === 'U')) || (e.ctrlKey && e.key === 'u')) {
        e.preventDefault();
      }
    };

    // Adding event listeners for the whole document
    document.addEventListener('contextmenu', handleRightClick);
    window.addEventListener('keydown', handleKeyDown);

    // Cleanup function to remove the event listeners when the component unmounts
    return () => {
      document.removeEventListener('contextmenu', handleRightClick);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []); // Empty dependency array means this effect will only run once (on mount)
  return (
    <div className="App">
      <AuthProvider>

        <DonationDashboard />
      </AuthProvider>
    </div>
  );
}

export default App;
